/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LoginPage_manager = {
    readonly firstName: string;
    readonly lastName: string;
    readonly " $refType": "LoginPage_manager";
};
export type LoginPage_manager$data = LoginPage_manager;
export type LoginPage_manager$key = {
    readonly " $data"?: LoginPage_manager$data;
    readonly " $fragmentRefs": FragmentRefs<"LoginPage_manager">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "LoginPage_manager",
    "type": "Manager",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "firstName",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "lastName",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '82ee0e9a08fd62278bebffe472a0c13b';
export default node;
